import { role } from "src/pods/realtime/util/role";
import { logEvent as execLogEventCommand } from "src/pods/webviewInit";

type Event = {
  eventName: string;
  eventValue?: string;
  metadata?: Record<string, unknown>;
};
//This isn't being used currently, make sure to update eventName as needed before use

export default function logEvent(event: Event) {
  event.eventName = `toolkit.${role}.${event.eventName}`;
  return execLogEventCommand(event);
}

export function logParentToolkitEvent(event: Event) {
  event.eventName = `paid_product.toolkit.${event.eventName}`;
  execLogEventCommand(event, "parent");
}

export function logNpsSurveyEvent({ eventName, metadata }: Event) {
  execLogEventCommand({
    eventName: `parent_beyond_nps_survey.${eventName}`,
    metadata,
  });
}
